import {gql} from '@apollo/client';

export const TRANSFER_PICKUP_TASK_APPOINTMENT = gql`
    mutation TransferPickupTaskAppointment(
        $sourceTaskId: String,
        $targetTaskId: String,
        $appointmentIds: [String!]!
    ) {
        transferPickupTaskAppointment(
            sourceTaskId: $sourceTaskId,
            targetTaskId: $targetTaskId,
            appointmentIds: $appointmentIds
        )
    }
`; 